// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Awards__Grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(150px, 1fr));
  gap: 20px;
  padding: 0;
  margin: 0 auto;
  justify-items: start;
  align-items: start;
  max-width: 68.6%;
  color: white;
  position: relative;
  transition: 1s;
}

.Awards__Title {
  max-width: 80%;
  position: sticky;
  top: 45svh;
}

.Awards__Info {
  max-width: 100%;
  padding-top: 34svh;
  padding-bottom: 34svh;
}

.Awards__Item {
  padding: 0em 0 2em 0;
}

.Awards__Item h1,
h2,
h3 {
  font-size: 18px;
  font-weight: bold;
}

.Awards__Item p {
  font-size: 18px;
  font-weight: normal;
}

.gradient__section {
  background: linear-gradient(
    180deg,
    rgba(0, 0, 0, 1) 0%,
    rgba(0, 0, 0, 0.9) 50%,
    rgba(0, 0, 0, 0) 100%
  );
  position: fixed;
  top: 0;
  height: 33svh;
  width: 100vw;
  z-index: 100;
}

.gradient__section2 {
  background: linear-gradient(
    180deg,
    rgba(0, 0, 0, 0) 0%,
    rgba(0, 0, 0, 1) 100%
  );
  position: fixed;
  bottom: 0;
  height: 33svh;
  width: 100vw;
  z-index: 100;
}

.test {
  display: flex;
  position: relative;
  left: -3.5em;
}

.test span {
  padding-left: 3.5em;
}

.test h1 {
  padding-right: 0.7em;
}

.Awards__Title__Item {
  padding: 0em 0 1em 0;
  display: flex;
  align-items: center;
  cursor: pointer;
}

.Awards__Title__Item h1 {
  position: relative;
  left: 0.5em;
}

.Awards__Title__Item:nth-child(2) {
  padding: 0em 0 0.5em 0;
  display: flex;
  align-items: center;
  cursor: pointer;
}

.Awards__Line {
  border: 1px solid white;
  border-radius: 10%;
  height: 45px;
  opacity: 50%;
}

.Awards__active {
  transform: translateY(4em);
  transition: 0.5s;
}

.teste2Awards {
  transform: translateY(0em);
  transition: 0.5s;
}

#Awards__Info__2 {
  display: none;
}

.grid-container__footer__mobile {
  display: grid;
  grid-template-columns: repeat(2, minmax(150px, 1fr));
  grid-gap: 10px;
  margin: 0 auto;
  padding: 0em 0 1.5em 0;
  width: 89.5%;
  color: white !important;
}

.grid-container__footer__about {
  position: relative;
  z-index: 10000;
  background-color: black;
}

@media all and (min-width: 1025px) and (max-width: 1700px) {
}

@media all and (max-width: 1024px) {
  .gradient__section {
    display: none;
  }

  .gradient__section2 {
    display: none;
  }

  .Awards__Grid {
    display: grid;
    grid-template-columns: repeat(1, minmax(150px, 1fr));
    gap: 10px;
    padding: 0;
    margin: 0 auto;
    justify-items: start;
    align-items: start;
    max-width: 89.5%;
    color: white;
    position: relative;
    padding-top: 0.5em;
    padding-bottom: 3em;
  }

  .navbar-container__test__Logo__Awards {
    display: grid;
    grid-template-columns: repeat(2, minmax(150px, 1fr));
    gap: 10px;
    margin: 0 auto;
    padding: 0;
    max-width: 89.5%;
    padding-top: 1.5em;
    padding-bottom: 1.5em;
    align-content: center;
    align-items: center;
    z-index: 101;
    position: fixed;
    top: 0px;
    left: 5.25%;
    width: 100%;
    background-color: black;
    transition: 1s;
  }

  .Awards__Info {
    max-width: 100%;
    padding-top: 0;
  }

  .test {
    display: flex;
    position: relative;
    left: 0em;
  }

  .test span {
    padding-left: 4.75em;
  }

  .Awards__Title {
    max-width: 100%;
    position: static;
    padding-bottom: 1.5em;
  }

  .test h1 {
    padding-right: 1.95em;
  }

  .Awards__Item p,
  h2 {
    padding-left: 4.2em;
  }

  .Awards__Item h1,
  h3,
  h2 {
    font-size: 18px;
    font-weight: bold;
  }

  .Awards__Item p {
    font-size: 18px;
    font-weight: normal;
  }
}
`, "",{"version":3,"sources":["webpack://./src/css/Awards.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,oDAAoD;EACpD,SAAS;EACT,UAAU;EACV,cAAc;EACd,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;;;EAGE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE;;;;;GAKC;EACD,eAAe;EACf,MAAM;EACN,aAAa;EACb,YAAY;EACZ,YAAY;AACd;;AAEA;EACE;;;;GAIC;EACD,eAAe;EACf,SAAS;EACT,aAAa;EACb,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,oDAAoD;EACpD,cAAc;EACd,cAAc;EACd,sBAAsB;EACtB,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,uBAAuB;AACzB;;AAEA;AACA;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,oDAAoD;IACpD,SAAS;IACT,UAAU;IACV,cAAc;IACd,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,oDAAoD;IACpD,SAAS;IACT,cAAc;IACd,UAAU;IACV,gBAAgB;IAChB,kBAAkB;IAClB,qBAAqB;IACrB,qBAAqB;IACrB,mBAAmB;IACnB,YAAY;IACZ,eAAe;IACf,QAAQ;IACR,WAAW;IACX,WAAW;IACX,uBAAuB;IACvB,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,qBAAqB;EACvB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;;IAEE,mBAAmB;EACrB;;EAEA;;;IAGE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;AACF","sourcesContent":[".Awards__Grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(2, minmax(150px, 1fr));\r\n  gap: 20px;\r\n  padding: 0;\r\n  margin: 0 auto;\r\n  justify-items: start;\r\n  align-items: start;\r\n  max-width: 68.6%;\r\n  color: white;\r\n  position: relative;\r\n  transition: 1s;\r\n}\r\n\r\n.Awards__Title {\r\n  max-width: 80%;\r\n  position: sticky;\r\n  top: 45svh;\r\n}\r\n\r\n.Awards__Info {\r\n  max-width: 100%;\r\n  padding-top: 34svh;\r\n  padding-bottom: 34svh;\r\n}\r\n\r\n.Awards__Item {\r\n  padding: 0em 0 2em 0;\r\n}\r\n\r\n.Awards__Item h1,\r\nh2,\r\nh3 {\r\n  font-size: 18px;\r\n  font-weight: bold;\r\n}\r\n\r\n.Awards__Item p {\r\n  font-size: 18px;\r\n  font-weight: normal;\r\n}\r\n\r\n.gradient__section {\r\n  background: linear-gradient(\r\n    180deg,\r\n    rgba(0, 0, 0, 1) 0%,\r\n    rgba(0, 0, 0, 0.9) 50%,\r\n    rgba(0, 0, 0, 0) 100%\r\n  );\r\n  position: fixed;\r\n  top: 0;\r\n  height: 33svh;\r\n  width: 100vw;\r\n  z-index: 100;\r\n}\r\n\r\n.gradient__section2 {\r\n  background: linear-gradient(\r\n    180deg,\r\n    rgba(0, 0, 0, 0) 0%,\r\n    rgba(0, 0, 0, 1) 100%\r\n  );\r\n  position: fixed;\r\n  bottom: 0;\r\n  height: 33svh;\r\n  width: 100vw;\r\n  z-index: 100;\r\n}\r\n\r\n.test {\r\n  display: flex;\r\n  position: relative;\r\n  left: -3.5em;\r\n}\r\n\r\n.test span {\r\n  padding-left: 3.5em;\r\n}\r\n\r\n.test h1 {\r\n  padding-right: 0.7em;\r\n}\r\n\r\n.Awards__Title__Item {\r\n  padding: 0em 0 1em 0;\r\n  display: flex;\r\n  align-items: center;\r\n  cursor: pointer;\r\n}\r\n\r\n.Awards__Title__Item h1 {\r\n  position: relative;\r\n  left: 0.5em;\r\n}\r\n\r\n.Awards__Title__Item:nth-child(2) {\r\n  padding: 0em 0 0.5em 0;\r\n  display: flex;\r\n  align-items: center;\r\n  cursor: pointer;\r\n}\r\n\r\n.Awards__Line {\r\n  border: 1px solid white;\r\n  border-radius: 10%;\r\n  height: 45px;\r\n  opacity: 50%;\r\n}\r\n\r\n.Awards__active {\r\n  transform: translateY(4em);\r\n  transition: 0.5s;\r\n}\r\n\r\n.teste2Awards {\r\n  transform: translateY(0em);\r\n  transition: 0.5s;\r\n}\r\n\r\n#Awards__Info__2 {\r\n  display: none;\r\n}\r\n\r\n.grid-container__footer__mobile {\r\n  display: grid;\r\n  grid-template-columns: repeat(2, minmax(150px, 1fr));\r\n  grid-gap: 10px;\r\n  margin: 0 auto;\r\n  padding: 0em 0 1.5em 0;\r\n  width: 89.5%;\r\n  color: white !important;\r\n}\r\n\r\n.grid-container__footer__about {\r\n  position: relative;\r\n  z-index: 10000;\r\n  background-color: black;\r\n}\r\n\r\n@media all and (min-width: 1025px) and (max-width: 1700px) {\r\n}\r\n\r\n@media all and (max-width: 1024px) {\r\n  .gradient__section {\r\n    display: none;\r\n  }\r\n\r\n  .gradient__section2 {\r\n    display: none;\r\n  }\r\n\r\n  .Awards__Grid {\r\n    display: grid;\r\n    grid-template-columns: repeat(1, minmax(150px, 1fr));\r\n    gap: 10px;\r\n    padding: 0;\r\n    margin: 0 auto;\r\n    justify-items: start;\r\n    align-items: start;\r\n    max-width: 89.5%;\r\n    color: white;\r\n    position: relative;\r\n    padding-top: 0.5em;\r\n    padding-bottom: 3em;\r\n  }\r\n\r\n  .navbar-container__test__Logo__Awards {\r\n    display: grid;\r\n    grid-template-columns: repeat(2, minmax(150px, 1fr));\r\n    gap: 10px;\r\n    margin: 0 auto;\r\n    padding: 0;\r\n    max-width: 89.5%;\r\n    padding-top: 1.5em;\r\n    padding-bottom: 1.5em;\r\n    align-content: center;\r\n    align-items: center;\r\n    z-index: 101;\r\n    position: fixed;\r\n    top: 0px;\r\n    left: 5.25%;\r\n    width: 100%;\r\n    background-color: black;\r\n    transition: 1s;\r\n  }\r\n\r\n  .Awards__Info {\r\n    max-width: 100%;\r\n    padding-top: 0;\r\n  }\r\n\r\n  .test {\r\n    display: flex;\r\n    position: relative;\r\n    left: 0em;\r\n  }\r\n\r\n  .test span {\r\n    padding-left: 4.75em;\r\n  }\r\n\r\n  .Awards__Title {\r\n    max-width: 100%;\r\n    position: static;\r\n    padding-bottom: 1.5em;\r\n  }\r\n\r\n  .test h1 {\r\n    padding-right: 1.95em;\r\n  }\r\n\r\n  .Awards__Item p,\r\n  h2 {\r\n    padding-left: 4.2em;\r\n  }\r\n\r\n  .Awards__Item h1,\r\n  h3,\r\n  h2 {\r\n    font-size: 18px;\r\n    font-weight: bold;\r\n  }\r\n\r\n  .Awards__Item p {\r\n    font-size: 18px;\r\n    font-weight: normal;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
